import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import StaffFullProfile from "@/components/hr/StaffFullProfile";

// Self-service entry point — staff can view their own 360° profile (same
// component as the Staff Directory uses, but with self-resolved staff id).
export default function MyProfile() {
  const { user } = useAuth();
  const [staffId, setStaffId] = useState(null);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/hr/staff/me")
      .then((r) => setStaffId(r.data?.id || r.data?.staff?.id))
      .catch(async () => {
        // Fallback: lookup by email in the staff list (admin path)
        try {
          const { data } = await api.get("/hr/staff");
          const list = Array.isArray(data) ? data : (data.items || []);
          const me = list.find((s) => (s.email || "").toLowerCase() === (user.email || "").toLowerCase());
          if (me) setStaffId(me.id);
          else setErr("Your HR record was not found. Please contact HR to be onboarded.");
        } catch (e) { setErr(formatApiError(e)); }
      });
  }, [user]);

  if (err) return <div className="dc-card p-6 text-sm text-red-600" data-testid="my-profile-error">{err}</div>;
  if (!staffId) return <div className="p-8 text-sm text-slate-500">Loading your profile…</div>;

  return (
    <div className="space-y-4">
      <div>
        <div className="font-mono-alt text-[10px] uppercase tracking-widest text-slate-500">SELF-SERVICE · DESCON/QMS/HR-PERSONAL</div>
        <h1 className="font-display text-2xl font-semibold text-slate-900">My Profile</h1>
        <p className="text-sm text-slate-600">Your complete employee record — salary, assets, warnings, defenses, leaves, tasks, performance.</p>
      </div>
      <div className="dc-card p-4 md:p-5">
        <StaffFullProfile staffId={staffId} />
      </div>
    </div>
  );
}
